var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBulbBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.875 29.25C13.875 28.6287 14.3787 28.125 15 28.125H21C21.6213 28.125 22.125 28.6287 22.125 29.25C22.125 29.8713 21.6213 30.375 21 30.375H15C14.3787 30.375 13.875 29.8713 13.875 29.25ZM14.875 33C14.875 32.3787 15.3787 31.875 16 31.875H20C20.6213 31.875 21.125 32.3787 21.125 33C21.125 33.6213 20.6213 34.125 20 34.125H16C15.3787 34.125 14.875 33.6213 14.875 33Z",
    fill: "currentColor",
    fillOpacity: 0.86
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.375 12.3271C6.375 6.46998 11.7058 1.875 18 1.875C24.2942 1.875 29.625 6.46998 29.625 12.3271L29.625 12.332C29.6106 15.6415 28.1871 18.9385 25.6583 21.337L25.6552 21.3399L23.9991 22.8987C23.7604 23.1234 23.625 23.4367 23.625 23.7645C23.625 25.3443 22.3443 26.625 20.7645 26.625H15.2355C13.6557 26.625 12.375 25.3443 12.375 23.7645C12.375 23.4367 12.2396 23.1234 12.0009 22.8987L10.3448 21.3399L10.3417 21.337C7.81292 18.9385 6.38941 15.6415 6.37501 12.332L6.375 12.3271ZM8.625 12.3247C8.63736 15.0031 9.79532 17.7169 11.8885 19.7029C11.889 19.7034 11.8895 19.7039 11.8901 19.7044L13.543 21.2602C14.2335 21.9101 14.625 22.8163 14.625 23.7645C14.625 24.1017 14.8983 24.375 15.2355 24.375H20.7645C21.1017 24.375 21.375 24.1017 21.375 23.7645C21.375 22.8163 21.7665 21.9102 22.457 21.2603C22.457 21.2603 22.457 21.2603 22.457 21.2603L24.1099 19.7044C24.1104 19.704 24.1109 19.7035 24.1114 19.703C26.2047 17.7169 27.3627 15.003 27.375 12.3246C27.3734 7.94922 23.3028 4.125 18 4.125C12.6972 4.125 8.62651 7.9493 8.625 12.3247Z",
    fill: "currentColor",
    fillOpacity: 0.86
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBulbBold);
export default __webpack_public_path__ + "static/media/ic_bulb_bold.2d22747fad0b2fd317f30f2db4f61e7b.svg";
export { ForwardRef as ReactComponent };